import React from 'react';
import { Card, ToggleContainer, Section, Subsection, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import UploadFileZone from '../../../components/upload/uploadFileZone';
import useAppContext from '../../../context/useAppContext';

const Cgv = ({ form, onChangeForm }) => {
    const [{ event, organization }] = useAppContext();
    const toast = React.useContext(ToastContext);

    const { t } = useTranslation();

    return (
        <Card.FormStep title={t('ticket.ticket_option.module.cgv.title')} id={'cgv'} rightComponent>
            <ToggleContainer
                toggle={Boolean(form.type_cgv)}
                title={t('ticket.ticket_option.module.cgv.cgv')}
                onChange={(synth, { checked }) => {
                    onChangeForm('type_cgv', checked);
                }}
            >
                <Section>
                    <Subsection>
                        <UploadFileZone
                            className={'without-margin'}
                            organization={organization}
                            onUpload={file => onChangeForm('cgv', file.url)}
                            onError={() => toast.error(t('ticket.ticket_option.module.cgv.error'))}
                            labelDropzone={t('ticket.event.dropzone_label')}
                            file={form.cgv}
                            onDelete={() => onChangeForm('cgv', null)}
                            getURLParams={() => ({ eventId: event.pk })}
                            getQueryParams={() => ({ type: 'pdf' })}
                            fileTypes={['.pdf']}
                            title={t('ticket.ticket_option.module.cgv.uploadCGV')}
                        />
                    </Subsection>
                </Section>
            </ToggleContainer>
        </Card.FormStep>
    );
};

Cgv.propTypes = {
    form: PropTypes.object.isRequired,
    onChangeForm: PropTypes.func.isRequired
};

export default Cgv;
